import script from "./AddAssignmentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAssignmentForm.vue?vue&type=script&setup=true&lang=js"

import "./AddAssignmentForm.vue?vue&type=style&index=0&id=e3ffd44c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3ffd44c"]])

export default __exports__